import { Field } from "formik";
import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { useDeepEffect } from "../../../abstracts";
import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInput,
  FieldInputFormatted,
  FieldInputNumber,
  FieldTextarea,
  SearchableList,
  WithDrawalCard,
  AddToolTip,
} from "../../../components";
import { getCountriesList, getStates } from "../../../services";
import {
  FORM_PLACEHOLDERS,
  getFormattedPhone,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
} from "../../../utils";
import HeadingAndTextComponent from "./HeadingAndTextComponent";

const checkSplChar = /[0-9!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/;
const isValidZip = /(^\d{5}$)|(^\d{9}$)|(^\d{5}-\d{4}$)/;
const isValidNo = /(^\d{3}-\d{3}-\d{4}$)/;
const isValidEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const addressBankDetailsRadioOptions = [
  { label: "As in employee records", value: 1 },
  { label: "Custom", value: 2 },
];
const accountTypeOptions = [
  {
    label: "Saving Account",
    value: 1,
  },

  {
    label: "Checking Account",
    value: 2,
  },
];

const AddressDetailsComponent = ({
  values,
  fields,
  handleChange,
  setFieldValue,
  setValues,
  countries,
  stateList,
  bankAccountDetails,
  addressDetails,
  filteredValues,
  selectedWithdrawalPlanSetUp,
}) => (
  <div className="bank-address-card">
    <Field
      isRequired
      name={`selectAddressDetails`}
      label="Select Address"
      size="xl"
      options={addressBankDetailsRadioOptions}
      selectedValue={values?.selectAddressDetails}
      onChange={(value) => {
        setFieldValue("selectAddressDetails", value);
        if (value === 1) setFieldValue("address", addressDetails);
        else setFieldValue("address", {});
      }}
      //disabled={isEdit && !isSave}
      component={FieldButtonGroup}
      validate={(selectedValue) => {
        return [undefined, null, ""].includes(selectedValue)
          ? "Required"
          : undefined;
      }}
    />
    {/* custom option */}
    {values?.selectAddressDetails === 2 && (
      <div>
        <Field
          size="smd"
          isRequired
          placeholder="Enter name"
          label={"Make Check Payable to"}
          name={"address.checkPayableTo"}
          type="text"
          value={get(values, "address.checkPayableTo")}
          onChange={handleChange}
          component={FieldInput}
          validate={(value) => {
            return [true].includes(value?.trim() === "")
              ? "Required"
              : [undefined, null, ""].includes(value)
              ? "Required"
              : get(values, "address.checkPayableTo").length > 150
              ? "Make Check Payable to should not Exceed 150 characters"
              : undefined;
          }}
        />
        <Field
          size="smd"
          isRequired
          placeholder="Type here"
          label={"Address"}
          name={"address.address1"}
          type="text"
          value={get(values, "address.address1")}
          onChange={handleChange}
          component={FieldTextarea}
          validate={(value) => {
            return [true].includes(value?.trim() === "")
              ? "Required"
              : [undefined, null, ""].includes(value)
              ? "Required"
              : checkSplChar.test(value) === true
              ? "City should contain only alphabets, spaces and hyphen"
              : get(values, "address.city", "").length > 35
              ? "City should not Exceed 35 characters"
              : undefined;
          }}
        />
        <Field
          size="md"
          isRequired
          name={"address.city"}
          label={"City"}
          placeholder="Enter city"
          type="text"
          autoComplete="off"
          value={get(values, "address.city")}
          onChange={handleChange}
          //disabled={isEdit && !isSave}
          component={FieldInput}
          validate={(value) => {
            return [undefined, null, ""].includes(value)
              ? "Required"
              : [true].includes(value?.trim() === "")
              ? "Required"
              : checkSplChar.test(value) === true
              ? "City should contain only alphabets, spaces and hyphen"
              : get(values, "address.city", "").length > 35
              ? "City should not Exceed 35 characters"
              : undefined;
          }}
        />

        <Field
          size="md"
          isRequired
          name={"address.countryId"}
          value={get(values, "address.countryId")}
          label="Country"
          options={
            countries &&
            countries.map((country, index) => ({
              label: country.code,
              value: country.id,
            }))
          }
          popupContent={
            <SearchableList
              label="Select Country"
              options={
                countries &&
                countries.map((country, index) => ({
                  label: country.code,
                  value: country.id,
                }))
              }
              onSelect={(value, label) => {
                setFieldValue(`address.${fields.country}`, label);
                setFieldValue(`address.${fields.countryId}`, value);
                setFieldValue(`address.${fields.countryCode}`, label);
                setFieldValue(`address.${fields.zipCode}`, null);
                value == 1 &&
                  setFieldValue(`address.${fields.foreignCountry}`, null) &&
                  setFieldValue(`address.${fields.foreignState}`, null) &&
                  setFieldValue(`address.${fields.foreignZipCode}`, null);
                value == 2 &&
                  setFieldValue(`address.${fields.state}`, null) &&
                  setFieldValue(`address.${fields.stateId}`, null);
                // if (value == 1)
                //     getStatesList(fields.countryId)
                //         .then((response) => {
                //             setStateList(response);
                //         })
                //         .catch((error) => {
                //             //Handle error
                //         });
              }}
              value={get(values, "address.countryId")}
              selectedValue={get(values, "address.countryId")}
            />
          }
          //disabled={isEdit && !isSave}
          component={FieldDropSide}
          validate={(value) => {
            return [undefined, null, ""].includes(value)
              ? "Required"
              : undefined;
          }}
        />
        {get(values, `address.${fields.country}`) == "USA" && (
          <>
            <Field
              size="md"
              isRequired
              name={`address.${fields.stateId}`}
              options={
                stateList &&
                stateList.map((state, index) => ({
                  label: state.stateDescription,
                  value: state.id,
                }))
              }
              value={get(values, `address.${fields.stateId}`)}
              label="State"
              direction="bottom"
              popupContent={
                <SearchableList
                  label="Select State"
                  options={
                    stateList &&
                    stateList.map((state, index) => ({
                      label: state.stateDescription,
                      value: state.id,
                    }))
                  }
                  onSelect={(value, label) => {
                    setFieldValue(`address.${fields.state}`, label);
                    setFieldValue(`address.${fields.stateId}`, value);
                  }}
                  selectedValue={get(values, `address.${fields.stateId}`)}
                  height="250px"
                  value={get(values, `address.${fields.stateId}`)}
                />
              }
              //disabled={isEdit && !isSave}
              component={FieldDropSide}
              validate={(value) => {
                return [undefined, null, ""].includes(value)
                  ? "Required"
                  : undefined;
              }}
            />
            <Field
              size="smd"
              isRequired
              placeholder="Enter zipcode"
              label={"Zip Code"}
              name={"address.zipCode"}
              type="text"
              value={get(values, `address.${fields.zipCode}`)}
              // validate={(val) => {
              //     return [null, undefined, ""].includes(
              //         values[fields.zipCode]
              //     )
              //         ? `${isLoanRequest ? "LO068" : "WL033"} : Required`
              //         : !isValidZip(values[fields.zipCode])
              //             ? `${isLoanRequest ? "LO069" : "WL032"
              //             } : ZIP Code should be in a format of XXXXX or XXXXXXXXX or XXXXX-XXXX, X being a number`
              //             : undefined;
              // }}
              onChange={handleChange}
              component={FieldInput}
              validate={(value) => {
                return [undefined, null, ""].includes(value)
                  ? "Required"
                  : isValidZip.test(value) === false
                  ? "ZIP Code should be in a format of XXXXX or XXXXXXXXX or XXXXX-XXXX, X being a number"
                  : undefined;
              }}
            />
          </>
        )}
        {get(values, `address.${fields.country}`) &&
          get(values, `address.${fields.country}`) !== "USA" && (
            <>
              <Field
                size="md"
                isRequired
                name={`address.${fields.foreignCountry}`}
                label={"Foreign country"}
                placeholder="Enter foreign country"
                type="text"
                autoComplete="off"
                value={get(values, `address.${fields.foreignCountry}`)}
                onChange={handleChange}
                component={FieldInput}
                validate={(value) => {
                  return [true].includes(value?.trim() === "")
                    ? "Required"
                    : [undefined, null, ""].includes(value)
                    ? "Required"
                    : checkSplChar.test(value) === true
                    ? "Foreign country should contain only alphabets, spaces and hyphen"
                    : get(values, `address.${fields.foreignCountry}`).length >
                      30
                    ? "Foreign country should not Exceed 30 characters"
                    : undefined;
                }}
              />

              <Field
                size="md"
                isRequired
                name={`address.${fields.foreignState}`}
                label={"Foreign state"}
                placeholder="Enter foreign state"
                type="text"
                autoComplete="off"
                value={get(values, `address.${fields.foreignState}`)}
                onChange={handleChange}
                component={FieldInput}
                validate={(value) => {
                  return [undefined, null, ""].includes(value)
                    ? "Required"
                    : checkSplChar.test(value) === true
                    ? "Foreign state should contain only alphabets, spaces and hyphen"
                    : get(values, `address.${fields.foreignState}`).length > 35
                    ? "Foreign state should not Exceed 35 characters"
                    : [true].includes(value?.trim() === "")
                    ? "Required"
                    : undefined;
                }}
              />

              <Field
                size="md"
                isRequired
                name={`address.${fields.foreignZipCode}`}
                label={"Foreign zip code "}
                placeholder="Enter"
                type="text"
                autoComplete="off"
                value={get(values, `address.${fields.foreignZipCode}`)}
                onChange={handleChange}
                //disabled={isEdit && !isSave}
                component={FieldInput}
                // validate={(val) =>
                //     [null, undefined, ""].includes(
                //         values[fields.foreignZipCode]
                //     )
                //         ? `${isLoanRequest ? "LO079" : "WL043"} : Required`
                //         : !isValidZip(values[fields.foreignZipCode])
                //             ? `${isLoanRequest ? "LO069" : "WL032"
                //             } : ZIP Code should be in a format of XXXXX or XXXXXXXXX or XXXXX-XXXX, X being a number`
                //             : undefined
                // }
                validate={(value) => {
                  return [undefined, null, ""].includes(value)
                    ? "Required"
                    : isValidZip.test(value) === false
                    ? "ZIP Code should be in a format of XXXXX or XXXXXXXXX or XXXXX-XXXX, X being a number"
                    : undefined;
                }}
              />
            </>
          )}

        <Field
          size="md"
          name={"address.mobileNumber"}
          label={"Mobile No"}
          type="text"
          autoComplete="off"
          value={getFormattedPhone(values?.address?.mobileNumber)}
          //onChange={handleChange}
          onChange={(e) => {
            setFieldValue(
              "address.mobileNumber",
              getFormattedPhone(e.target.value)
            );
          }}
          // disabled={isEdit && !isSave}
          component={FieldInputFormatted}
          placeholder={FORM_PLACEHOLDERS.phone}
          maxLength="12"
          validate={(value) => {
            return ![undefined, null, ""].includes(value) &&
              isValidNo.test(value) === false
              ? "Mobile No  must be in a valid format – XXX-XXX-XXXX , X being a number"
              : undefined;
          }}
        />

        <Field
          size="smd"
          isRequired
          placeholder=" "
          label={"Email ID"}
          name={"address.emailId"}
          type="text"
          value={get(values, "address.emailId")}
          onChange={handleChange}
          component={FieldInput}
          validate={(value) => {
            return [undefined, null, ""].includes(value)
              ? "Required"
              : isValidEmail.test(value) === false
              ? " Email ID is invalid."
              : get(values, "address.emailId").length > 80
              ? "Email ID should not Exceed 80 characters"
              : undefined;
          }}
        />
      </div>
    )}
    {/* As in employee records option */}
    {values?.selectAddressDetails === 1 && (
      <>
        <div className="textHeading mt-3">Cheque payable to</div>
        <div className="textWord" style={{ fontSize: "14px" }}>
          {filteredValues.firstName + " " + filteredValues.lastName}
        </div>
        {console.log("aa", addressDetails?.checkPayableTo)}
        <div className="textHeading mt-3">Address</div>
        <div className="textWord" style={{ fontSize: "14px" }}>
          {`${addressDetails?.address1} , ${addressDetails?.city}, ${addressDetails?.zipCode}.`}
        </div>
      </>
    )}
  </div>
);
const BankDetailsComponent = ({
  values,
  fields,
  handleChange,
  setFieldValue,
  setValues,
  countries,
  stateList,
  bankAccountDetails,
  addressDetails,
  selectedWithdrawalPlanSetUp,
  filteredValues,
}) => (
  <div className="bank-address-card">
    <Field
      isRequired
      name={`selectBankDetails`}
      label="Select bank details"
      size="xl"
      options={addressBankDetailsRadioOptions}
      selectedValue={values?.selectBankDetails}
      onChange={(value) => {
        setFieldValue("selectBankDetails", value);
        if (value === 1) setFieldValue("bankInformation", bankAccountDetails);
        else setFieldValue("bankInformation", {});
      }}
      //disabled={isEdit && !isSave}
      component={FieldButtonGroup}
    />
    {/* custom option */}
    {values?.selectBankDetails === 2 && (
      <>
        <Field
          size="smd"
          isRequired
          placeholder="Enter name"
          label={"Name of financial institution"}
          name={"bankInformation.nameOfTheFinancialInstitution"}
          type="text"
          value={get(values, "bankInformation.nameOfTheFinancialInstitution")}
          onChange={handleChange}
          validate={(value) => {
            return [true].includes(value?.trim() === "")
              ? "Required"
              : [undefined, null, ""].includes(value)
              ? "Required"
              : checkSplChar.test(value) === true
              ? "Name of financial instituion  should contain only alphabets, spaces and hyphen"
              : get(values, "bankInformation.nameOfTheFinancialInstitution")
                  .length > 50
              ? "Name of financial instituion should not Exceed 50 characters"
              : undefined;
          }}
          component={FieldInput}
        />

        <Field
          size="smd"
          isRequired
          placeholder="Enter account holder name"
          label={"Account holder name"}
          name={"bankInformation.accountHolderName"}
          type="text"
          value={get(values, "bankInformation.accountHolderName")}
          onChange={handleChange}
          component={FieldInput}
          validate={(value) => {
            return [undefined, null, ""].includes(value)
              ? "Required"
              : [true].includes(value?.trim() === "")
              ? "Required"
              : get(values, "bankInformation.accountHolderName").length > 150
              ? "Account holder name should not Exceed 150 characters"
              : undefined;
          }}
        />

        <Field
          isRequired
          name={"bankInformation.typeOfAccount"}
          size="md"
          label={"Account type"}
          options={accountTypeOptions}
          selectedValue={get(values, "bankInformation.typeOfAccount")}
          onChange={(value) => {
            setFieldValue("bankInformation.typeOfAccount", value);
          }}
          //disabled={isEdit && !isSave}
          component={FieldButtonGroup}
          validate={(selectedValue) => {
            return [undefined, null, ""].includes(selectedValue)
              ? "Required"
              : undefined;
          }}
        />
        <Field
          size="smd"
          placeholder="Enter account number"
          isRequired
          label={"Account Number (Checking or Saving)"}
          name={"bankInformation.checkingSavingsAccountNumber"}
          type="text"
          value={get(values, "bankInformation.checkingSavingsAccountNumber")}
          onChange={handleChange}
          component={FieldInputNumber}
          validate={(value) => {
            return [undefined, null, ""].includes(value)
              ? "Required"
              : get(values, "bankInformation.checkingSavingsAccountNumber") >
                999999999999999999
              ? "Account Number should not Exceed 18 characters"
              : undefined;
          }}
        />

        <Field
          size="smd"
          placeholder="Enter routing number"
          isRequired
          label={"Routing Number Of bank or credit union"}
          name={"bankInformation.ABARoutingNumberforBankOfCreditUnion"}
          type="text"
          value={get(
            values,
            "bankInformation.ABARoutingNumberforBankOfCreditUnion"
          )}
          onChange={handleChange}
          component={FieldInputNumber}
          validate={(value) => {
            return [undefined, null, ""].includes(value)
              ? "Required"
              : get(
                  values,
                  "bankInformation.ABARoutingNumberforBankOfCreditUnion"
                ) > 999999999
              ? "Routing Number should not Exceed 9 characters"
              : undefined;
          }}
        />
      </>
    )}
    {/* As in employee records option */}

    {values?.selectBankDetails === 1 && (
      <>
        <div className="textHeading mb-2">Bank Details</div>

        <WithDrawalCard style={1} cssStyle={{ padding: "16px 16px" }}>
          <HeadingAndTextComponent
            headingText="Account holder"
            contentText={
              (filteredValues.firstName + " " + filteredValues.lastName)
                .length > 10 ? (
                <div>
                  <AddToolTip
                    name={
                      filteredValues.firstName + " " + filteredValues.lastName
                    }
                  >
                    {(
                      filteredValues.firstName +
                      " " +
                      filteredValues.lastName
                    ).slice(0, 10)}
                    ...
                  </AddToolTip>
                </div>
              ) : (
                <div className="sourceHierarchy_Card_Headerfont">
                  {filteredValues.firstName + " " + filteredValues.lastName}
                </div>
              )
            }
            // {
            //   filteredValues.firstName + " " + filteredValues.lastName
            // }
          />
          <div style={{ marginLeft: "20px" }}>
            <HeadingAndTextComponent
              headingText="Account type"
              contentText={
                bankAccountDetails?.typeOfAccount === 1 ? "Savings" : "Checking"
              }
            />
          </div>
          <div style={{ marginLeft: "20px" }}>
            <HeadingAndTextComponent
              headingText="Account number"
              contentText={bankAccountDetails?.checkingSavingsAccountNumber}
            />
          </div>
          <div style={{ marginLeft: "20px" }}>
            <HeadingAndTextComponent
              headingText="Routing number"
              contentText={
                bankAccountDetails?.abaRoutingNumberforBankOfCreditUnion
              }
            />
          </div>
        </WithDrawalCard>
      </>
    )}
  </div>
);

function AddressAndBankDetailsComponent(props) {
  const {
    values,
    fields,
    handleChange,
    setFieldValue,
    setValues,
    countries,
    stateList,
    bankAccountDetails,
    addressDetails,
    selectedWithdrawalPlanSetUp,
    ...rest
  } = props;

  const paymentOptions = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.PAYMENT_OPTIONS
  );

  return (
    <div>
      <Field
        isRequired
        name={fields.paymentMethod}
        label="Choose Payment Method"
        size="xl"
        options={paymentOptions}
        selectedValue={values[fields.paymentMethod]}
        onChange={(value) => {
          const tempValues = { ...values };
          tempValues[fields.paymentMethod] = value;
          tempValues[fields.checkFee] =
            value === 1 ? selectedWithdrawalPlanSetUp.checkFees : "";
          tempValues["selectBankDetails"] = 1;
          tempValues["selectAddressDetails"] = 1;
          tempValues[fields.eftFee] =
            value === 2 ? selectedWithdrawalPlanSetUp.eftFee : "";
          if (value === 2) {
            tempValues["address"] = {};
            tempValues["bankInformation"] = bankAccountDetails;
          } else if (value === 1) {
            tempValues["bankInformation"] = {};
            tempValues["address"] = addressDetails;
          }
          setValues(tempValues);
        }}
        //disabled={isEdit && !isSave}
        component={FieldButtonGroup}
        validate={(value) => {
          return [undefined, null, ""].includes(value) ? "Required" : undefined;
        }}
      />

      {values[fields.paymentMethod] === 2 && (
        <>
          <div className="slider-heading pb-10">Bank details</div>
          <BankDetailsComponent {...props} />
        </>
      )}
      {values[fields.paymentMethod] === 1 && (
        <>
          <div className="slider-heading pb-10">Address</div>
          <AddressDetailsComponent {...props} />
        </>
      )}
    </div>
  );
}

export default AddressAndBankDetailsComponent;
